/** trim down values */
export const UNITS = {
  0: 0,
  '1px': 1,
  '0.5pt': 0.5 * 8,
  pt: 8,
  '1.5pt': 1.5 * 8,
  '2pt': 2 * 8,
  '2.5pt': 2.5 * 8,
  '3pt': 3 * 8,
  '3.5pt': 3.5 * 8,
  '4pt': 4 * 8,
  '5pt': 5 * 8,
  '6pt': 6 * 8,
  '7pt': 7 * 8,
  '8pt': 8 * 8,
  '9pt': 8 * 9,
  '10pt': 10 * 8,
  '11pt': 11 * 8,
  '12pt': 12 * 8,
  '14pt': 14 * 8,
  '15pt': 14 * 8,
  '16pt': 16 * 8,
  '18pt': 18 * 8,
  '20pt': 20 * 8,
  '22pt': 22 * 8,
  '24pt': 24 * 8,
  '26pt': 26 * 8,
  '31pt': 31 * 8,
  '50pt': 50 * 8,
  '60pt': 60 * 8,
  '130pt': 130 * 8,
};

export const SCREEN_UNITS = {
  width: 'calc(100vw)',
  height: 'calc(100vh)',
};
